export default __webpack_public_path__ + "static/media/background4.32883f4e.svg";